export const FEATURES_CONSTANTS = {
  title: "Key Benefits of VMware Cloud",
  list: [
    {
      label: "Unified Infrastructure Management",
      text: "Centralized control over resources across multiple cloud environments, simplifying operations and reducing complexity.",
    },
    {
      label: "Scalability",
      text: "Easily scale resources up or down based on demand, ensuring optimal performance and cost-efficiency.",
    },
    {
      label: "Security and Compliance",
      text: "Robust security measures and compliance certifications to protect data and applications. ",
    },
    {
      label: "Disaster Recovery",
      text: "Integrated solutions for data backup and disaster recovery, ensuring business continuity.",
    },
    {
      label: "Developer-Friendly Tools",
      text: "Support for modern application development with Kubernetes and containerization technologies.",
    },
  ],
};
